var _path, _path2, _path3, _path4, _ellipse;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgentParticipant(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 12C15.75 14.0711 14.0711 15.75 12 15.75C9.92893 15.75 8.25 14.0711 8.25 12C8.25 9.92893 9.92893 8.25 12 8.25C14.0711 8.25 15.75 9.92893 15.75 12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2793 10.3861C5.0093 6.7898 8.18882 4.08301 12.0005 4.08301C15.8123 4.08301 18.9918 6.7898 19.7218 10.3861M19.2238 15.1134C18.2111 17.4313 16.1154 19.1677 13.5763 19.6831"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54492 11.3867C2.54492 10.8344 2.99264 10.3867 3.54492 10.3867L5.69646 10.3867L5.69646 15.114L3.54492 15.114C2.99264 15.114 2.54492 14.6663 2.54492 14.114L2.54492 11.3867Z",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4551 11.3867C21.4551 10.8344 21.0074 10.3867 20.4551 10.3867L18.3035 10.3867L18.3035 15.114L20.4551 15.114C21.0074 15.114 21.4551 14.6663 21.4551 14.114L21.4551 11.3867Z",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.9996,
    cy: 19.8414,
    rx: 1.57577,
    ry: 1.57577
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgentParticipant);
export default __webpack_public_path__ + "static/media/agent-participant.604d118cd2ced1cd31f23ccad54e6fa5.svg";
export { ForwardRef as ReactComponent };